const cookieName = 'PipelyneSessionId';

async function postData(url = '', data = {}) {
    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

async function createSession() {    
    const response = await postData('/api/Event/Session', {
        UserAgent: navigator.userAgent,
        ScreenWidth: screen.width,
        ScreenHeight: screen.height
    });
    
    const session = await response.json();
    
    return session.id;
}

async function getSessionId() {
    const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${cookieName}=`))
        ?.split('=')[1];
    
    if (cookieValue != null) {
        return cookieValue;
    }
    
    const sessionId = await createSession();
    document.cookie = `${cookieName}=${sessionId}`;
    return sessionId;
}
 
export async function trackEvent(eventType) {
    const sessionId = await getSessionId();
    await postData('/api/Event', {
            SessionId: sessionId,
            Type: eventType
        });
}